class AjaxForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.boundOnSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.boundOnSubmit);
  }

  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener('submit', this.boundOnSubmit);
    }
  }

  async onSubmit(event) {
    event.preventDefault();

    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const submitBtn = this.form.querySelector('[type="submit"]');

    try {
      const formData = new FormData(this.form);
      
      if (this.form.getAttribute('action') === window.routes.cart_add_url || this.form.action.includes('/cart/add')) {
        await window.CartAPI.add(formData, { form: this.form, button: submitBtn });
      } else {
        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.classList.add('opacity-50', 'pointer-events-none');
          this.originalBtnText = submitBtn.innerHTML;
          submitBtn.innerHTML = '<span class="material-symbols-outlined animate-spin" aria-hidden="true">progress_activity</span>';
        }

        const response = await fetch(this.form.action, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newForm = doc.getElementById(this.id);
        if (newForm) {
          this.innerHTML = newForm.innerHTML;
        } else {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      this.isSubmitting = false;
      if (submitBtn && this.form.getAttribute('action') !== window.routes.cart_add_url && !this.form.action.includes('/cart/add')) {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.classList.remove('opacity-50', 'pointer-events-none');
        if (this.originalBtnText) submitBtn.innerHTML = this.originalBtnText;
      }
    }
  }
}

customElements.define('ajax-form', AjaxForm);
